 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"8f2cee35f0446f866a413e043187bc50c2d76b00","2":"94726e6d","3":"4d62a23293b69be4819bf002b19a21f8715987c0","4":"7eea9dae5f115fdadfe60572d6f4b5ca948d80f7","5":"43f545cf210cf69ec7625eae48ade78f2d90d801","6":"a48df646072fe9f4538310545600bf5c60eebc0f","7":"3bd6865947fbc6094c8485a488fdff1d29d8852e","8":"ad5e2d7fbfded9ffc8910c44929528a2e8211ff0","9":"0863f71a183d25274733451b62c99a99e43d4243","10":"72ab4c4b5acc49a0117f9190894f36083c20264f","11":"732b4f4924f899dfd05343d589fb1b8092127588","12":"9849a3227f3a381393f1cdb3b0641657cbc56be7","13":"9c64ef181a226e9502d98dacf3c6988c9fb8eeaa","14":"a2db95f72da15c6aa523431e72e608aa476e9c64","15":"cac8c069a2a62a6b43f9895f14636beddafe5835","18":"component---cache-caches-gatsby-plugin-offline-app-shell-js","19":"component---src-pages-404-en-js","20":"component---src-pages-404-js","21":"component---src-pages-about-us-en-js","22":"component---src-pages-anti-corruption-policy-en-js","23":"component---src-pages-application-development-modernization-en-js","24":"component---src-pages-auditoria-gratis-para-o-seu-site-wordpress-pt-js","25":"component---src-pages-aumente-a-visibilidade-do-seu-site-wordpress-pt-js","26":"component---src-pages-ciberseguranca-pt-js","27":"component---src-pages-cloud-infraestrutura-pt-js","28":"component---src-pages-cloud-infrastructure-en-js","29":"component---src-pages-code-ethics-conduct-en-js","30":"component---src-pages-codigo-etica-conduta-pt-js","31":"component---src-pages-complaints-management-policy-en-js","32":"component---src-pages-contact-us-en-js","33":"component---src-pages-contacte-nos-pt-js","34":"component---src-pages-cyber-security-en-js","35":"component---src-pages-dados-ia-pt-js","36":"component---src-pages-data-ai-en-js","37":"component---src-pages-desenvolvimento-modernizacao-aplicacoes-pt-js","38":"component---src-pages-enterprise-ai-en-js","39":"component---src-pages-estrategia-esg-pt-js","40":"component---src-pages-ferramentas-pt-js","41":"component---src-pages-ia-empresarial-pt-js","42":"component---src-pages-index-en-js","43":"component---src-pages-index-pt-js","44":"component---src-pages-log-ai-en-js","45":"component---src-pages-log-ai-pt-js","46":"component---src-pages-o-seu-site-wordpress-esta-lento-e-com-bugs-pt-js","47":"component---src-pages-politica-anticorrupcao-pt-js","48":"component---src-pages-politica-gestao-reclamacoes-pt-js","49":"component---src-pages-politica-privacidade-pt-js","50":"component---src-pages-privacy-policy-en-js","51":"component---src-pages-proteja-o-seu-site-wordpress-e-o-seu-negocio-pt-js","52":"component---src-pages-services-en-js","53":"component---src-pages-servicos-pt-js","54":"component---src-pages-sobre-nos-pt-js","55":"component---src-pages-strategy-esg-en-js","56":"component---src-pages-toolbox-en-js","57":"component---src-pages-torne-o-seu-site-wordpress-mais-rapido-pt-js","58":"component---src-pages-trabalho-pt-js","59":"component---src-pages-work-en-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"37fe62f9f5c090ea4073","2":"884a94e7734c97b73b0d","3":"4608316cd195a129d4f4","4":"c3f2cd147248a39650e2","5":"ddda6bdc20bb6ec67b48","6":"42603732bfa6cfa193e7","7":"69351877807a6ea46ca6","8":"32fac2f04aafa82b62a3","9":"77d9cdcff55239a740d3","10":"42023d3ff8501f46d814","11":"bac479f754ed994d8738","12":"292b8dbd88f714f12f6d","13":"a9d9d3993e8d1f1dc5ab","14":"039f7be218654037e3f8","15":"cc11e16f078e25b7ba2d","18":"2f73c4a51ede1a6a39e3","19":"398503e61ac7866bf6cd","20":"1d733bdc6114b56ab274","21":"cd2d2bbd99dd25bc1dfd","22":"738a09ce3866cb27a3a9","23":"31c10189c96da6447d8f","24":"bad2ab83b19c4a2ff2bf","25":"26188729ebd86cd86cfa","26":"4e00f36a8126042e5e58","27":"f30ba20781806b4ba6d9","28":"8c8c753a9ae396ab01b0","29":"6f9d7c495dcfb8f09276","30":"baefbed5c9af6ed49c92","31":"d9179067502e5ed351dd","32":"5fd15b2d4418ebb125b9","33":"86bd1981bd4a494fa050","34":"36ad5d44889afc9c3050","35":"b6943c0776abf87662e0","36":"c43cc08b8c64346b4b1f","37":"6152a5f4ed8335d74b87","38":"248b50347060f4207726","39":"df8ca7bff4501ea84bb3","40":"3ecf1b5ae4c279e0507c","41":"a5d8557fc25d4a60344e","42":"3b60c79bc77cbd34c6ee","43":"332dc09f9fcca9c2bf4d","44":"dca279148aaaa7854042","45":"83e371292f4548df5670","46":"86f41c02b43d26835ebb","47":"753b7d3171819c0e2a43","48":"f65934b586e109a1fc27","49":"0af7e569e2190295b4ea","50":"c4cc6bbf6a37e811ce3a","51":"da2119f4f553a1782a39","52":"85fe1df98cda98a5f356","53":"fa1d5ad799b45289ddcf","54":"c3d6485246602991a05e","55":"6e4d4fb0beaf3b44022a","56":"4e122f04c58de0b7f6ca","57":"15403d4d1fc102376bd4","58":"f1751b1a6ef95ceffe57","59":"0a056cc1407fa4d28be3","62":"84e741ad78e3319e3e7b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"8f2cee35f0446f866a413e043187bc50c2d76b00","2":"94726e6d","3":"4d62a23293b69be4819bf002b19a21f8715987c0","4":"7eea9dae5f115fdadfe60572d6f4b5ca948d80f7","5":"43f545cf210cf69ec7625eae48ade78f2d90d801","6":"a48df646072fe9f4538310545600bf5c60eebc0f","7":"3bd6865947fbc6094c8485a488fdff1d29d8852e","8":"ad5e2d7fbfded9ffc8910c44929528a2e8211ff0","9":"0863f71a183d25274733451b62c99a99e43d4243","10":"72ab4c4b5acc49a0117f9190894f36083c20264f","11":"732b4f4924f899dfd05343d589fb1b8092127588","12":"9849a3227f3a381393f1cdb3b0641657cbc56be7","13":"9c64ef181a226e9502d98dacf3c6988c9fb8eeaa","14":"a2db95f72da15c6aa523431e72e608aa476e9c64","15":"cac8c069a2a62a6b43f9895f14636beddafe5835","18":"component---cache-caches-gatsby-plugin-offline-app-shell-js","19":"component---src-pages-404-en-js","20":"component---src-pages-404-js","21":"component---src-pages-about-us-en-js","22":"component---src-pages-anti-corruption-policy-en-js","23":"component---src-pages-application-development-modernization-en-js","24":"component---src-pages-auditoria-gratis-para-o-seu-site-wordpress-pt-js","25":"component---src-pages-aumente-a-visibilidade-do-seu-site-wordpress-pt-js","26":"component---src-pages-ciberseguranca-pt-js","27":"component---src-pages-cloud-infraestrutura-pt-js","28":"component---src-pages-cloud-infrastructure-en-js","29":"component---src-pages-code-ethics-conduct-en-js","30":"component---src-pages-codigo-etica-conduta-pt-js","31":"component---src-pages-complaints-management-policy-en-js","32":"component---src-pages-contact-us-en-js","33":"component---src-pages-contacte-nos-pt-js","34":"component---src-pages-cyber-security-en-js","35":"component---src-pages-dados-ia-pt-js","36":"component---src-pages-data-ai-en-js","37":"component---src-pages-desenvolvimento-modernizacao-aplicacoes-pt-js","38":"component---src-pages-enterprise-ai-en-js","39":"component---src-pages-estrategia-esg-pt-js","40":"component---src-pages-ferramentas-pt-js","41":"component---src-pages-ia-empresarial-pt-js","42":"component---src-pages-index-en-js","43":"component---src-pages-index-pt-js","44":"component---src-pages-log-ai-en-js","45":"component---src-pages-log-ai-pt-js","46":"component---src-pages-o-seu-site-wordpress-esta-lento-e-com-bugs-pt-js","47":"component---src-pages-politica-anticorrupcao-pt-js","48":"component---src-pages-politica-gestao-reclamacoes-pt-js","49":"component---src-pages-politica-privacidade-pt-js","50":"component---src-pages-privacy-policy-en-js","51":"component---src-pages-proteja-o-seu-site-wordpress-e-o-seu-negocio-pt-js","52":"component---src-pages-services-en-js","53":"component---src-pages-servicos-pt-js","54":"component---src-pages-sobre-nos-pt-js","55":"component---src-pages-strategy-esg-en-js","56":"component---src-pages-toolbox-en-js","57":"component---src-pages-torne-o-seu-site-wordpress-mais-rapido-pt-js","58":"component---src-pages-trabalho-pt-js","59":"component---src-pages-work-en-js"}[chunkId]||chunkId) + "." + {"0":"439cc5fdeff9ba143e37","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
